import { useThemeObserver } from '@atlaskit/tokens';

export const RovoDevAgentsIcon = () => {
	const { colorMode, light } = useThemeObserver();
	const isLightMode = colorMode === light;
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.0123 3.27288C12.3955 2.91395 11.6359 2.90911 11.0152 3.25836C11.0064 3.26485 10.9971 3.27094 10.9874 3.27658L10.9873 3.27663L10.986 3.27741C10.5867 3.51015 10.2848 3.8698 10.1189 4.28886C10.0268 4.52385 9.97754 4.77777 9.97754 5.03912V7.73475L13.3255 9.68348L13.3257 9.6836C14.1479 10.1605 14.6521 11.0421 14.6521 11.9981L14.6521 18.9571C14.6521 19.2693 14.5978 19.574 14.496 19.8594L18.9874 17.2439L18.9879 17.2436C19.6151 16.8799 19.9998 16.2078 19.9998 15.4776V8.51862C19.9998 7.79133 19.6128 7.11627 18.9875 6.75238L18.9874 6.75233L13.0123 3.27288Z"
				fill={isLightMode ? '#1868DB' : '#357DE8'}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.0223 18.9609C14.0223 19.2226 13.9728 19.4768 13.8806 19.712C13.7144 20.1312 13.4121 20.4908 13.0125 20.7234L13.0124 20.7234C13.0027 20.7291 12.9934 20.7352 12.9846 20.7417C12.3639 21.0909 11.6044 21.0861 10.9876 20.7272L10.9875 20.7271L5.01241 17.2477L5.01232 17.2476C4.38699 16.8838 4 16.2087 4 15.4814L4 8.52239C4 7.79222 4.38472 7.12009 5.01191 6.75639L9.50381 4.14062C9.40202 4.426 9.34771 4.73069 9.34771 5.04289V12.0019C9.34771 12.9578 9.85176 13.8393 10.6739 14.3163L10.6743 14.3165L14.0223 16.2653V18.9609Z"
				fill={isLightMode ? '#1868DB' : '#357DE8'}
			/>
		</svg>
	);
};
